export function SubmitIcon(props) {
    const { color = "currentColor"} = props;
    return (
        <svg width="64" height="64" viewBox="0 0 64 64" fill={color}>
            <path d="M51.2574 21.3866C52.4312 19.9521 52.187 17.8638 50.7121 16.7222C49.2373 15.5806 47.0901 15.8181 45.9164 17.2526L27.533 39.7202L17.8129 30.3702C16.4727 29.081 14.3118 29.0926 12.9863 30.3961C11.6609 31.6996 11.6728 33.8014 13.013 35.0905L25.4362 47.0407C26.1252 47.7034 27.0713 48.0501 28.0386 47.9941C29.006 47.9382 29.9032 47.485 30.5066 46.7475L51.2574 21.3866Z" />
        </svg>
    );
}

export function NextIcon(props) {

    const {className, color = "currentColor"} = props;
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 -9 10 40" fill="none" className={className}>
            <path d="M2.5 20L11.5 11L2.5 2" stroke={color} strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}